import clsx from 'clsx';

function mergeProps(...args) {
  const [initialProps, ...followingProps] = args;
  const result = followingProps.reduce(
    (acc, propsToMerge) => {
      if (!propsToMerge) return acc;
      for (const prop in propsToMerge) {
        const propInAcc = acc[prop];
        const propInCurr = propsToMerge[prop];
        if (typeof propInAcc === "function" && typeof propInCurr === "function" && // This is a lot faster than a regex.
        // Credits: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/utils/src/mergeProps.ts
        prop[0] === "o" && prop[1] === "n" && prop.charCodeAt(2) >= /* 'A' */
        65 && prop.charCodeAt(2) <= /* 'Z' */
        90) {
          acc[prop] = chain(propInAcc, propInCurr);
        } else if ((prop === "class" || prop === "className" || prop === "UNSAFE_className") && typeof propInAcc === "string" && typeof propInCurr === "string") {
          acc[prop] = clsx(propInAcc, propInCurr);
        } else if (prop === "style") {
          if (typeof propInCurr === "string") {
            acc[prop] = `${propInAcc ?? ""} ${propInCurr}`.trim();
          } else {
            acc[prop] = Object.assign({}, propInAcc ?? {}, propInCurr ?? {});
          }
        } else {
          acc[prop] = propInCurr !== void 0 ? propInCurr : propInAcc;
        }
      }
      return acc;
    },
    { ...initialProps }
  );
  return result;
}
function chain(...callbacks) {
  return (...args) => {
    for (const callback of callbacks) {
      if (typeof callback === "function") {
        callback(...args);
      }
    }
  };
}

export { chain, mergeProps };
